import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { CategoryRestrictionProfileConfigurationsEffects } from './category-restriction-profile-configuration.effects';
import { categoryRestrictionProfileConfigurationReducer } from './category-restriction-profile-configuration.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('restriction-profile-configuration', categoryRestrictionProfileConfigurationReducer),
    EffectsModule.forFeature([CategoryRestrictionProfileConfigurationsEffects]),
  ],
  providers: [],
})
export class CategoryRestrictionProfileConfigurationModule {}
